import { render, staticRenderFns } from "./UserDetailPhotos.vue?vue&type=template&id=8582238c&scoped=true"
import script from "./UserDetailPhotos.vue?vue&type=script&lang=js"
export * from "./UserDetailPhotos.vue?vue&type=script&lang=js"
import style0 from "./UserDetailPhotos.vue?vue&type=style&index=0&id=8582238c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8582238c",
  null
  
)

export default component.exports